import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { Card, CardContent, colors, Container, Divider, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
    root: {
        // height: '80px',
        fontFamily: "Amiri-Regular",
        // borderBottomWidth: "5px",
        // borderBottomStyle: "solid",
        color: "#000",
        paddingTop: "0.5rem"
    },
    rootBodys: {
        fontFamily: "Amiri-Regular",
        backgroundColor: colors.grey[300],
        borderBottomColor: colors.grey[700],
        borderBottomWidth: "5px",
        borderBottomStyle: "solid",
        color: "#000",
        direction:"rtl",
    },
    content: {
        alignItems: "center",
        //display: "flex",
        fontFamily: "Amiri-Regular",
    },
    title: {
        fontWeight: 700,
        textAlign: "center",
        fontFamily: "Amiri-Regular",
    },
}));

function TotalMezan({ infoData }) {

    const cls = useRptAF();
    const { t } = useTranslation(["forms"]);

    const totals = infoData.tot;

    const classes = useStyles();
    return (
        <Card className={clsx(classes.root)}>
            <Grid item container className={classes.rootBodys}
            
           >
                <CardContent className={classes.content}>
                    <Grid container xs={12} /*className={cls.rootchip}*/ style={{
                        fontFamily: "Amiri-Regular",
                        direction: "rtl"
                    }}>
                        <Grid container xs={4} style={{ fontWeight: "bold" }}>
                            <Grid xs={2} style={{ fontWeight: "bold" }}>
                                <Typography
                                    className={classes.title}
                                    variant="body1"
                                >
                                    {t("prev-balance")}
                                </Typography>
                            </Grid>
                            <Grid xs={10} style={{ fontWeight: "bold" }}>
                                <Container
                                    style={{
                                        justifyContent: "center",
                                    }}
                                    maxWidth={false}
                                >
                                    <Typography variant="body1" style={{ fontFamily: "Amiri-Regular" }}>
                                        {" "}
                                        {t("dept") + ": "}
                                        {parseFloat(infoData.tot?.prevDept)?.toFixed(2)}

                                        {/* {data.reduce((a, v) => (a = a + v.OB_DR_AMT_L + v.val_open_dept), 0).toFixed(2)}{" "} */}
                                    </Typography>
                                    <Divider />
                                    <Typography variant="body1" style={{ fontFamily: "Amiri-Regular" }}>
                                        {" "}
                                        {t("credit") + ": "}
                                        {parseFloat(infoData.tot?.prevCredit)?.toFixed(2)}

                                        {/* {data.reduce((a, v) => (a = a + v.OB_CR_AMT_L + v.val_open_credit), 0).toFixed(2)}{" "} */}
                                    </Typography>
                                </Container>
                            </Grid>
                        </Grid>
                        <Grid container xs={4} style={{ fontWeight: "bold" }}>
                            <Grid xs={2} style={{ fontWeight: "bold" }}>
                                <Typography
                                    className={classes.title}
                                    variant="body1"
                                >
                                    {t("acc-move")}
                                </Typography>
                            </Grid>

                            <Grid xs={10} style={{ fontWeight: "bold" }}>
                                <Container
                                    style={{
                                        // display:'flex',
                                        // margin:0,
                                        justifyContent: "center",
                                    }}
                                    maxWidth={false}
                                >
                                    <Typography variant="body1" style={{ fontFamily: "Amiri-Regular" }}>
                                        {" "}
                                        {t("dept") + ": "}
                                        {parseFloat(infoData.tot?.moveDept)?.toFixed(2)}

                                        {/* {data.reduce((a, v) => (a = a + v.DR_AMT_L), 0).toFixed(2)}{" "} */}
                                    </Typography>
                                    <Divider />
                                    <Typography variant="body1" style={{ fontFamily: "Amiri-Regular" }}>
                                        {" "}
                                        {t("credit") + ": "}
                                        {parseFloat(infoData.tot?.moveCredit)?.toFixed(2)}

                                        {/* {data.reduce((a, v) => (a = a + v.CR_AMT_L), 0).toFixed(2)}{" "} */}
                                    </Typography>
                                </Container>
                            </Grid>
                        </Grid>

                        <Grid container xs={4} style={{ fontWeight: "bold" }}>
                            <Grid xs={2} style={{ fontWeight: "bold" }}>
                                <Typography
                                    className={classes.title}
                                    variant="body1"
                                >
                                    {t("acc-balance")}
                                </Typography>
                            </Grid>
                            <Grid xs={10} style={{ fontWeight: "bold" }}>
                                <Container
                                    style={{
                                        justifyContent: "center",
                                    }}
                                    maxWidth={false}
                                >
                                    <Typography variant="body1" style={{ fontFamily: "Amiri-Regular" }}>
                                        {" "}
                                        {t("dept") + ": "}
                                        {parseFloat(infoData.tot?.balDept)?.toFixed(2)}

                                        {/* {data.reduce((a, v) => (a = a + v.End_DR_AMT_L), 0).toFixed(2)}{" "} */}
                                    </Typography>
                                    <Divider />
                                    <Typography variant="body1" style={{ fontFamily: "Amiri-Regular" }}>
                                        {" "}
                                        {t("credit") + ": "}
                                        {parseFloat(infoData.tot?.balCredit)?.toFixed(2)}

                                        {/* {data.reduce((a, v) => (a = a + v.End_CR_AMT_L), 0).toFixed(2)}{" "} */}
                                    </Typography>
                                </Container>
                            </Grid>

                        </Grid>
                    </Grid>
                </CardContent>
            </Grid>
        </Card>

    );
}

export default TotalMezan;
